import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=dae5f962&"
import script from "./InputMoney.vue?vue&type=script&lang=ts&"
export * from "./InputMoney.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports